/**
 * Tipos e rótulos da administração de usuários — Optimale Grid (frontend, US-1804).
 *
 * Criado em: 19/10/2026 · Última modificação: 19/10/2026 · Versão: 1.0.0
 *
 * Espelha a resposta de `/api/v1/usuarios` (US-1803): nunca há senha nem sessão nos dados.
 */
import { marcaAtual } from "../marca";

export type Janela = { dias: number[]; inicio: string; fim: string; fuso?: string };

export type UsuarioAdm = {
  id: string; login: string; nome: string; email: string | null;
  perfil: "cliente" | "suporte" | "integrador"; empresa: string | null; empresas_atribuidas: string[];
  papeis: string[]; ativo: boolean; janela_acesso: Janela | null; bloqueado: boolean; bloqueado_ate: string | null;
  ultimo_login: string | null; email_confirmado: boolean; criado_em: string | null; versao: number; em_sessao: boolean;
  pode_gerenciar?: boolean;
};

export type Pagina = { total: number; itens: UsuarioAdm[]; limite: number; deslocamento: number };
export type Evento = { instante: string; evento: string; ip: string | null; detalhe: string };

export const PAPEIS: [string, string][] = [
  ["operador", "Operador"], ["supervisor", "Supervisor"], ["coordenador", "Coordenador"], ["engenharia", "Engenharia"],
  ["campo", "Campo"], ["atendimento", "Atendimento"], ["administrador", "Administrador"],
];
export const NOME_PAPEL: Record<string, string> = Object.fromEntries(PAPEIS);
/** Rótulo do perfil com o nome do integrador (Sprint 45: a marca vem da API). */
export const PERFIS: Record<string, string> = new Proxy({} as Record<string, string>, {
  get: (_alvo, perfil: string) => ({ cliente: "Cliente", suporte: `Suporte ${marcaAtual().empresa}`,
    integrador: `Integrador ${marcaAtual().empresa}` } as Record<string, string>)[perfil],
});
export const DIAS = ["Seg", "Ter", "Qua", "Qui", "Sex", "Sáb", "Dom"];

export const EVENTOS: Record<string, string> = {
  login_ok: "Entrou", login_falha: "Senha errada", login_bloqueado: "Bloqueado por tentativas",
  fora_do_horario: "Tentou fora do horário", usuario_inativo: "Tentou com a conta desativada", logout: "Saiu",
  sessao_substituida: "Entrou em outro lugar", usuario_criado: "Conta criada", token_painel: "Abriu painel do Grafana",
  convite_enviado: "Convite enviado", cadastro_confirmado: "Cadastro confirmado", recuperacao_pedida: "Pediu nova senha",
  recuperacao_limitada: "Pedidos de senha limitados", senha_redefinida: "Senha redefinida",
  usuario_alterado: "Dados alterados", usuario_desativado: "Conta desativada", usuario_reativado: "Conta reativada",
  usuario_desbloqueado: "Conta desbloqueada", sessao_encerrada_admin: "Sessão encerrada pela administração",
  redefinicao_enviada: "Link de nova senha enviado", gestao_recusada: "Tentativa de gestão recusada",
};

export const quando = (iso: string | null) => (iso ? new Date(iso).toLocaleString("pt-BR") : "—");

export function situacao(u: UsuarioAdm): { texto: string; classe: string } {
  if (!u.ativo) return { texto: "Desativado", classe: "situacao-rejeitado" };
  if (u.bloqueado) return { texto: "Bloqueado", classe: "situacao-pendente" };
  // convite pendente: tem e-mail, nunca confirmou nem entrou (quem foi criado com senha pela CLI não recebeu convite)
  if (u.email && !u.email_confirmado && !u.ultimo_login) return { texto: "Convite pendente", classe: "situacao-pendente" };
  return { texto: "Ativo", classe: "situacao-validado" };
}

export function descreverJanela(j: Janela | null): string {
  if (!j) return "sem restrição";
  return `${j.dias.map((d) => DIAS[d]).join(", ")} · ${j.inicio.slice(0, 5)}–${j.fim.slice(0, 5)}`;
}
